import { render, staticRenderFns } from "./strategy-radio.component.vue?vue&type=template&id=742d590f&scoped=true&"
import script from "./strategy-radio.component.vue?vue&type=script&lang=ts&"
export * from "./strategy-radio.component.vue?vue&type=script&lang=ts&"
import style0 from "./strategy-radio.component.vue?vue&type=style&index=0&id=742d590f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d590f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
